import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth, isManager } from '../auth/AuthContext';

const ROLE_LABEL: Record<string, string> = {
  'embrace-user': 'Adviser',
  'embrace-manager': 'Manager',
  'sl-admin': 'SL Admin',
};

export function Layout({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();

  return (
    <div className="flex h-screen bg-shell font-sans text-ink">
      <aside className="flex w-60 flex-col bg-navy text-white">
        <div className="px-5 py-5">
          <div className="text-[15px] font-bold tracking-tight">
            Embrace Returns
          </div>
          <div className="mt-0.5 text-[10px] uppercase tracking-[1px] text-white/40">
            Powered by Pivotal
          </div>
        </div>

        <nav className="flex-1 px-3">
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `block rounded-lg px-3 py-2 text-[13px] font-medium transition-colors ${
                isActive ? 'bg-white/10 text-white' : 'text-white/70 hover:bg-white/5'
              }`
            }
          >
            Inbox
          </NavLink>
        </nav>

        <div className="border-t border-white/10 px-5 py-4">
          <div className="truncate text-[12.5px] font-medium">{user?.name}</div>
          <div className="truncate text-[11px] text-white/50">{user?.email}</div>
          <div className="mt-1 inline-block rounded-full bg-white/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white/70">
            {user ? ROLE_LABEL[user.role] ?? user.role : ''}
            {isManager(user) ? ' · all leads' : ''}
          </div>
          <button
            onClick={signOut}
            className="mt-3 block text-[12px] text-white/50 hover:text-white"
          >
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
}
